import React from 'react';
import { LucideIcon } from 'lucide-react';

interface PageHeaderProps {
  title: string;
  description: string;
  icon?: LucideIcon;
  iconColor?: string;
  gradientColors?: {
    from: string;
    via?: string;
    to: string;
  };
  badge?: string;
  className?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  icon: Icon,
  badge,
  className = '',
}) => {
  const headingId = React.useId();
  
  return (
    <section className={`page-hero ${className}`} aria-labelledby={headingId}>
      <div className="page-hero__grid" aria-hidden="true" />
      <div className="page-hero__glow page-hero__glow--left" aria-hidden="true" />
      <div className="page-hero__glow page-hero__glow--right" aria-hidden="true" />

      <div className="page-hero__content">
        {badge && (
          <div className="page-hero__badge">
            {badge}
          </div>
        )}

        {Icon && (
          <div className="page-hero__icon" aria-hidden="true">
            <Icon />
          </div>
        )}

        <h1 id={headingId} className="page-hero__title">{title}</h1>
        <p className="page-hero__description">{description}</p>
      </div>
    </section>
  );
};

export default PageHeader;
